class RhythmMomentCard extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (window.matchMedia('(pointer: fine)').matches) return;

    // On touch screens the first tap on a card reveals its overlay; a tap on
    // the already-revealed card follows the product link.
    const cardLink = event.target.closest('.rhythm-moment-card__link');
    if (!cardLink && event.target.closest('form, button, a')) return;

    const wasExpanded = this.hasAttribute('expanded');
    if (cardLink) {
      if (wasExpanded) return;
      event.preventDefault();
    }

    const grid = this.closest('.rhythm-moments__grid, .product-pair__grid');

    if (grid) {
      grid.querySelectorAll('rhythm-moment-card[expanded]').forEach((card) => {
        card.removeAttribute('expanded');
      });
    }

    if (!wasExpanded) this.setAttribute('expanded', '');
  }
}

if (!window.customElements.get('rhythm-moment-card')) {
  window.customElements.define('rhythm-moment-card', RhythmMomentCard);
}
